// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__HocLd","paramInput":"JobSimulator_paramInput__3ox0J","input":"JobSimulator_input__2NqWJ"};